<template>
    <div class="row">
        Pomoc
    </div>
</template>

<script>
    export default {
        name: "Help"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Help.vue